module.exports = __webpack_public_path__ + "static/media/addrole.1e29b4f1.svg";